import { Link } from 'react-router-dom';

const stats = [
  {
    icon: 'ri-file-search-line',
    color: '#D4A373',
    value: '持續累積中',
    label: '保單健檢完成數',
    note: '每一份都認真對待',
  },
  {
    icon: 'ri-refresh-line',
    color: '#5C5470',
    value: '每年定期',
    label: '年度檢視服務',
    note: '確保保障與人生同步',
  },
  {
    icon: 'ri-heart-pulse-line',
    color: '#FF8C69',
    value: '四大方向',
    label: '諮詢重點',
    note: '醫療保障・家庭風險・退休準備・企業福利',
  },
  {
    icon: 'ri-shield-check-line',
    color: '#D4A373',
    value: '先理解，再設計',
    label: '服務承諾',
    note: '只推需要的，不賣最多的',
  },
];

export default function TestimonialsStats() {
  return (
    <>
      {/* Stats Section */}
      <section className="bg-[#5C5470] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
              OUR COMMITMENT
            </p>
            <h2
              className="font-serif font-bold text-white"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              服務數據與承諾
            </h2>
            <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4 mb-4"></div>
            <p className="text-white/70 max-w-lg mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
              數字是參考，承諾才是核心
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {stats.map((s) => (
              <div
                key={s.label}
                className="bg-white/8 border border-white/12 rounded-2xl p-8 text-center hover:bg-white/12 transition-colors duration-200"
              >
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-full mx-auto mb-5"
                  style={{ backgroundColor: `${s.color}25` }}
                >
                  <i className={`${s.icon} text-2xl`} style={{ color: s.color }}></i>
                </div>
                <p
                  className="font-serif font-bold text-white mb-2"
                  style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.3' }}
                >
                  {s.value}
                </p>
                <p className="text-[#D4A373] font-semibold mb-3" style={{ fontSize: '1.0625rem' }}>
                  {s.label}
                </p>
                <p className="text-white/60" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                  {s.note}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#F8F5F0] py-24 lg:py-32">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
            YOUR TURN
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470] mb-5"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            您也想重新整理自己的保障結構嗎？
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mb-8"></div>
          <p
            className="text-gray-600 max-w-xl mx-auto mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            先從一次保單健檢開始，讓保險建築師陪您看懂現況、找到缺口、排出優先順序。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約一對一諮詢
            </Link>
            <Link
              to="/about#health-check-form"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-download-line"></i>
              下載保單健檢表
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
